import Vue from './configs/vue'
import App from './App.vue'
import router from './configs/router'
import store from './store/store'
import VModal from 'vue-js-modal'

import './registerServiceWorker'
import 'vue-material-design-icons/styles.css'
import 'flag-icon-css/css/flag-icon.css'
import './assets/sass/app.scss'

Vue.use(VModal)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
